<template>
 <router-view></router-view>

</template>

<script>
import { mapActions } from 'vuex';
import { useLockScreen } from '@/composables/useLockScreen';

export default {
  name: 'App',
  setup() {
    const { startIdleTimer, stopIdleTimer, clearLockState } = useLockScreen();
    return { startIdleTimer, stopIdleTimer, clearLockState };
  },
  methods: {
    ...mapActions('system', ['fetchSettings'])
  },
  mounted() {
    this.fetchSettings();

    // Start idle timer if user is authenticated
    const token = localStorage.getItem('auth_token');
    if (token) {
      this.startIdleTimer();
    }
  },
  beforeUnmount() {
    this.stopIdleTimer();
  },
  watch: {
    // Watch for route changes to manage idle timer
    '$route'(to) {
      const token = localStorage.getItem('auth_token');
      if (to.name === 'login') {
        // Clear lock state on login page
        this.clearLockState();
      } else if (token && to.name !== 'lock-screen') {
        // Restart idle timer on authenticated pages
        this.startIdleTimer();
      }
    }
  },
  components: {
  }
}
</script>
